import { message } from "antd";
import { useCallback, useState } from "react";
import sdk from "../../sdk";

export const useOrderListDetail = (_id: string) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<string | null>(null);
  const [orderData, setOrderData] = useState<string | null>(null);

  const generateOrderListDetail = useCallback(() => {
    setLoading(true);
    if (_id) {
      sdk
        .generateOrderListDetail({ _id })
        .then((res) => {
          setData(res.generateOrderListDetail);
          setLoading(false);
        })
        .catch((err) => {
          message.warn(err.response?.errors[0]?.message, 2);
          setLoading(false);
        })
        .finally(() => setLoading(false));
    }
  }, [_id]);

  const generateOrderListOrders = useCallback(() => {
    setLoading(true);
    if (_id) {
      sdk
        .generateOrderListOrders({ _id })
        .then((res) => {
          setOrderData(res.generateOrderListOrders);
          setLoading(false);
        })
        .catch((err) => {
          message.warn(err.response?.errors[0]?.message, 2);
          setLoading(false);
        })
        .finally(() => setLoading(false));
    }
  }, [_id]);

  const regenerateOrderListFile = useCallback(() => {
    setLoading(true);
    if (_id) {
      sdk
        .regenerateOrderListFile({ orderListId: _id })
        .then((res) => {
          setData(res.regenerateOrderListFile);
          message.success("Файл амжилттай үүслээ");
          setLoading(false);
        })
        .catch((err) => {
          message.warn(err.response?.errors[0]?.message, 2);
          setLoading(false);
        })
        .finally(() => setLoading(false));
    }
  }, [_id]);

  const [perUserData, setPerUserData] = useState<string | null>(null);

  const generateOrderListDetailPerUser = useCallback(() => {
    setLoading(true);
    if (_id) {
      sdk
        .generateOrderListDetailPerUser({ _id })
        .then((res) => {
          setPerUserData(res.generateOrderListDetailPerUser);
          setLoading(false);
        })
        .catch((err) => {
          message.warn(err.response?.errors[0]?.message, 2);
          setLoading(false);
        })
        .finally(() => setLoading(false));
    }
  }, [_id]);

  return {
    data,
    orderData,
    perUserData,
    loading,
    generateOrderListDetail,
    generateOrderListOrders,
    regenerateOrderListFile,
    generateOrderListDetailPerUser,
  };
};
